import { render } from "./important-dates.vue?vue&type=template&id=47a35109"
import script from "./important-dates.vue?vue&type=script&lang=js"
export * from "./important-dates.vue?vue&type=script&lang=js"

import exportComponent from "/srv/clubs/releases/20240415150343/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__